import { render, staticRenderFns } from "./RelatedOccupationsJ.vue?vue&type=template&id=5ec43a67&"
import script from "./RelatedOccupationsJ.vue?vue&type=script&lang=js&"
export * from "./RelatedOccupationsJ.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports